import './hendrickstavern/style';
import FormStructure from './hendrickstavern/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js